<template>
  <div>
    <Header :role="role" :header="$t(role)" showSettings />
    <b-container class="container-wide compliance-home">
      <div class="mt-5" />
      <b-alert
        show
        variant="success"
        class="text-center"
        v-if="dashboardMessage || editDasboardMessage"
      >
        <div class="flex-row" v-if="!editDasboardMessage">
          {{ this.dashboardMessage }}
          <img
            class="ml-2"
            v-if="['COMPLIANCE'].includes(role)"
            @click="
              () => {
                editDasboardMessage = true;
              }
            "
            src="../../assets/edit-icon.svg"
            height="14px"
          />
        </div>

        <div
          class="d-flex justify-content-center"
          v-if="editDasboardMessage && ['COMPLIANCE'].includes(role)"
        >
          <b-form-input
            v-model="dashboardMessage"
            class="text-center"
            placeholder="Sisesta sõnum"
          ></b-form-input>
          <b-button
            variant="success"
            class="ml-2"
            size="sm"
            @click="saveDashboardMessage"
          >
            Salvesta
          </b-button>
          <b-button
            variant="danger"
            class="ml-2"
            size="sm"
            @click="deleteDashboardMessage"
          >
            Kustuta
          </b-button>
        </div>
      </b-alert>

      <div
        v-if="
          !dashboardMessage &&
            !editDasboardMessage &&
            ['COMPLIANCE'].includes(role)
        "
        class="d-flex flex-row-reverse "
      >
        <img
          class="ml-2 mb-4 mr-2"
          @click="
            () => {
              editDasboardMessage = true;
            }
          "
          src="../../assets/edit-icon.svg"
          height="14px"
        />
      </div>

      <!-- Partner Limit Check URL Section -->
      <div v-if="role === 'PARTNER' && partnerLimitCheckUrl" class="mb-3 d-flex align-items-center">
        <span class="text-muted small mr-2">{{ $t('LIMIT_CHECK_URL') }}:</span>
        <a :href="partnerLimitCheckUrl" target="_blank" class="small">{{ partnerLimitCheckUrl }}</a>
        <b-icon
          icon="clipboard"
          class="ml-2"
          style="cursor: pointer; font-size: 0.9rem;"
          @click="copyPartnerLimitCheckUrl"
          v-b-tooltip.hover
          :title="$t('COPY')"
        />
      </div>

      <!-- Multi-Offer CTA Cards -->
      <div v-if="role === 'SHOP' && featureMultiOffer" class="cta-cards-row mb-4">
        <router-link :to="{ name: 'SelfServeMultiOffer' }" class="cta-card cta-card--white">
          <div class="cta-card__content">
            <h3 class="cta-card__title">Uus pakkumine</h3>
            <p class="cta-card__desc">Koosta pakkumine samm-sammult</p>
          </div>
          <button class="cta-card__btn cta-card__btn--outline">Alusta</button>
        </router-link>

        <div class="cta-card cta-card--purple" @click="openQuickOfferModal">
          <div class="cta-card__content">
            <h3 class="cta-card__title cta-card__title--light">Kiire pakkumine</h3>
            <p class="cta-card__desc cta-card__desc--light">Lae üles hinnapakkumine ja saa maksed koheselt</p>
          </div>
          <button class="cta-card__btn cta-card__btn--white">Alusta</button>
        </div>
      </div>

      <!-- Quick Offer Modal -->
      <b-modal
        v-model="showQuickOfferModal"
        title="Kiire pakkumine"
        size="md"
        centered
        hide-footer
        @hidden="resetQuickOffer"
      >
        <div class="quick-offer-upload">
          <label
            :class="['quick-offer-dropzone', { 'quick-offer-dropzone--dragging': quickOfferDragging }]"
            @dragover.prevent="quickOfferDragging = true"
            @dragleave="quickOfferDragging = false"
            @drop.prevent="handleQuickOfferDrop"
          >
            <input
              type="file"
              multiple
              class="quick-offer-file-input"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
              @change="handleQuickOfferFiles"
            />
            <div class="quick-offer-dropzone__text">
              <b-icon icon="cloud-upload" font-scale="2" class="mb-2"></b-icon>
              <p class="mb-1">Lohista failid siia</p>
              <span class="btn btn-sm btn-outline-secondary">Vali fail(id)</span>
            </div>
          </label>
        </div>

        <div v-if="quickOfferFiles.length" class="quick-offer-files mt-3">
          <div v-for="(file, i) in quickOfferFiles" :key="i" class="quick-offer-file-item">
            <span class="quick-offer-file-name">{{ file.name }}</span>
            <button class="quick-offer-file-remove" @click="removeQuickOfferFile(i)">&times;</button>
          </div>
        </div>

        <div class="mt-3">
          <label class="mb-1 d-block font-weight-bold" style="font-size: 0.85rem;">Juhis</label>
          <b-form-textarea
            v-model="quickOfferPrompt"
            rows="2"
            max-rows="4"
            placeholder="Palun koosta pakkumine"
            style="background-color: #fff;"
          ></b-form-textarea>
        </div>

        <b-button
          variant="primary"
          block
          class="mt-3"
          :disabled="quickOfferSubmitting"
          @click="submitQuickOffer"
        >
          <b-spinner v-if="quickOfferSubmitting" small class="mr-1"></b-spinner>
          Koosta pakkumine
        </b-button>
      </b-modal>

      <b-card>
        <b-tabs content-class="mt-3" @input="onTabChange">
          <!-- Tab 1: Queries -->
          <b-tab :title="$t('QUERIES')" active>
            <b-row>
              <b-col>
                <b-dropdown :text="$t('QUERY_FILTERS')" variant="primary">
              <div class="dropdown-item filter-dropdown-item">
                <b-form-checkbox v-model="allSelected" @change="toggleAll">
                  {{
                    allSelected
                      ? $t('STATUSES.ALL_SELECTED')
                      : selected && selected.length > 0
                      ? $t('STATUSES.SELECT_ALL')
                      : $t('STATUSES.NONE_SELECTED')
                  }}
                </b-form-checkbox>
              </div>
              <b-dropdown-divider></b-dropdown-divider>
              <b-form-checkbox-group stacked v-model="selected" name="filter">
                <div
                  v-for="(status, index) in getStatusOptions"
                  :key="index"
                  class="dropdown-item filter-dropdown-item"
                >
                  <b-form-checkbox :value="status.value">
                    {{ status.text }}
                  </b-form-checkbox>
                </div>
              </b-form-checkbox-group>
            </b-dropdown>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group class="mb-0 search-form">
                <b-input-group class="search-input">
                  <b-form-input
                    v-model="filter"
                    debounce="300"
                    autofocus
                    :placeholder="$t('TYPE_TO_SEARCH')"
                  />
                  <b-input-group-append>
                    <b-btn
                      type="button"
                      variant="primary"
                      @click="filter = ''"
                      :disabled="!filter"
                      >{{ $t('CLEAR') }}</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-table
          outlined
          show-empty
          :busy="loading"
          :current-page="currentPage"
          :fields="fields"
          :items="filteredQueries"
          stacked="md"
          class="mt-2 mb-2"
          :empty-text="$t('NO_RECORDS')"
        >
          <template v-slot:head(contractAmount)>
            <!-- translate AMOUNT and NO_VAT with separate rows -->
            <span class="custom-header">
              {{ $t('AMOUNT') }}
              <br />
              {{ $t('NO_VAT') }}
            </span>
          </template>

          <template #cell(queryId)="data">
            <span class="">#{{ data.value }}</span>
          </template>

          <template #cell(sellerOfferNr)="data">
            <div
              v-if="data.value"
              class="truncate"
              v-b-tooltip="{
                title: data.value,
                trigger: 'hover',
                container: 'body',
                disabled: data.value.length < 18,
              }"
            >
              {{ data.value }}
            </div>
          </template>

          <template #cell(custName)="data">
            <div v-if="data.value" class="last-edited">
              <b>{{ data.value }}</b>
            </div>
          </template>
          <template #cell(contractAmount)="data">
            <div v-if="data.value" class="float-right">{{ data.value }} €</div>
          </template>
          <template #cell(status)="data">
            <div :class="'status ' + statusStyle(data.value) + ' table-status'">
              {{ $t(`QUERYSTATUS.${data.value}`) }}
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="actions">
              <router-link
                :to="`/selfserve/multi-offer/${row.item.queryId}`"
                v-if="row.item.multiOfferGroupId && row.item.status === 'P'"
                v-b-tooltip.hover
                :title="$t('EDIT')"
                ><img alt="edit" src="../../assets/edit-icon.svg"
              /></router-link>

              <router-link
                :to="`/selfserve/offers/${row.item.queryId}`"
                v-else-if="
                  row.item.status === 'P' && row.item.product === 'SELFSERVE'
                "
                v-b-tooltip.hover
                :title="$t('EDIT')"
                ><img alt="edit" src="../../assets/edit-icon.svg"
              /></router-link>

              <router-link
                :to="`/${role.toLowerCase()}/query/${row.item.queryId}/edit`"
                v-else
                v-b-tooltip.hover
                :title="$t('EDIT')"
                ><img alt="edit" src="../../assets/edit-icon.svg"
              /></router-link>
              <span
                v-b-tooltip.hover
                :title="
                  !(
                    ['PARTNER', 'SHOP', 'COMPLIANCE'].includes(role) &&
                    ['P', 'YS'].includes(row.item.status)
                  )
                    ? `${$t('QUERY_IN_STATUS')} '${$t(
                        `QUERYSTATUS.${row.item.status}`,
                      )}' ${$t('CANNOT_BE_ANNULLED')}`
                    : $t('ANNUL')
                "
              >
                <a
                  @click="openAnnulModal(row.item.queryId, row.index)"
                  :class="{
                    'action--disabled': !(
                      ['PARTNER', 'SHOP', 'COMPLIANCE'].includes(role) &&
                      ['P', 'YS'].includes(row.item.status)
                    ),
                  }"
                >
                  <img src="../../assets/delete-icon.svg" />
                </a>
              </span>
            </div>
          </template>
          <template slot="table-busy">
            <RenderSpinner :fixed="false" />
          </template>
        </b-table>
        <RenderDeleteModal
          :show="showAnnulModal"
          @ok="closeAnnulModal(true)"
          @cancel="closeAnnulModal()"
          :label="$t('ARE_YOU_SURE_ANNUL_QUERY')"
        />
        <b-row>
          <b-col>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              @change="changePage"
              class="my-0"
            />
          </b-col>
          <b-col md="3">
            <b-form-group class="mb-0">
              <b-form-select
                class="per-page-select"
                :options="pageOptions"
                v-model="perPage"
              />
            </b-form-group>
          </b-col>
        </b-row>
          </b-tab>

          <!-- Tab 2: Limit Requests (conditionally visible) -->
          <b-tab v-if="showLimitChecks && ['PARTNER', 'SHOP', 'COMPLIANCE', 'CREDIT'].includes(role)" :title="$t('LIMIT_REQUESTS')">
            <b-row>
              <b-col>
                <b-dropdown :text="$t('STATUS_FILTERS')" variant="primary">
                  <div class="dropdown-item filter-dropdown-item">
                    <b-form-checkbox v-model="limitAllSelected" @change="toggleAllLimitFilters">
                      {{
                        limitAllSelected
                          ? $t('STATUSES.ALL_SELECTED')
                          : limitStatusSelected && limitStatusSelected.length > 0
                          ? $t('STATUSES.SELECT_ALL')
                          : $t('STATUSES.NONE_SELECTED')
                      }}
                    </b-form-checkbox>
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-form-checkbox-group stacked v-model="limitStatusSelected" name="limitFilter">
                    <div
                      v-for="(status, index) in limitStatusOptions"
                      :key="index"
                      class="dropdown-item filter-dropdown-item"
                    >
                      <b-form-checkbox :value="status.value">
                        {{ status.text }}
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </b-dropdown>
              </b-col>
              <b-col>
                <b-form>
                  <b-form-group class="mb-0 search-form">
                    <b-input-group class="search-input">
                      <b-form-input
                        v-model="limitFilter"
                        debounce="300"
                        autofocus
                        :placeholder="$t('TYPE_TO_SEARCH')"
                      />
                      <b-input-group-append>
                        <b-btn
                          type="button"
                          variant="primary"
                          @click="limitFilter = ''"
                          :disabled="!limitFilter"
                          >{{ $t('CLEAR') }}</b-btn
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
            <b-table
              outlined
              show-empty
              :busy="limitRequestsLoading"
              :current-page="limitCurrentPage"
              :fields="visibleLimitFields"
              :items="filteredLimitRequests"
              stacked="md"
              class="mt-2 mb-2"
              :empty-text="$t('NO_RECORDS')"
            >
              <template #cell(limitId)="data">
                <span class="">#{{ data.value }}</span>
              </template>

              <template #cell(partnerName)="data">
                <div v-if="data.value && ['COMPLIANCE', 'CREDIT'].includes(role)">
                  {{ data.value }}
                </div>
              </template>

              <template #cell(companyName)="data">
                <div v-if="data.value" class="last-edited">
                  <b>{{ data.value }}</b>
                </div>
              </template>

              <template #cell(requestedLimit)="data">
                <div v-if="data.value > 0" class="float-right">{{ data.value }} €</div>
                <div v-else class="float-right">-</div>
              </template>

              <template #cell(lastResult)="data">
                <div :class="'status ' + resultStyle(data.value) + ' table-status'">
                  {{ formatResult(data.value) }}
                </div>
              </template>

              <template #cell(issuedLimit)="data">
                <div v-if="data.value > 0" class="float-right">{{ data.value }} €</div>
                <div v-else class="float-right">-</div>
              </template>

              <template #cell(createdAt)="data">
                <div v-if="data.value">{{ formatDate(data.value) }}</div>
              </template>

              <template #cell(actions)="row">
                <div class="actions">
                  <router-link
                    :to="`/${role.toLowerCase()}/limit-request/${row.item.limitId}/details`"
                    v-b-tooltip.hover
                    :title="$t('VIEW_DETAILS')"
                    ><img alt="view" src="../../assets/edit-icon.svg"
                  /></router-link>
                </div>
              </template>

              <template slot="table-busy">
                <RenderSpinner :fixed="false" />
              </template>
            </b-table>
            <b-row>
              <b-col>
                <b-pagination
                  :total-rows="limitTotalRows"
                  :per-page="limitPerPage"
                  v-model="limitCurrentPage"
                  class="my-0"
                />
              </b-col>
              <b-col md="3">
                <b-form-group class="mb-0">
                  <b-form-select
                    class="per-page-select"
                    :options="pageOptions"
                    v-model="limitPerPage"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ALERT } from '../../store/alert';
import { Header, RenderDeleteModal, RenderSpinner } from '@/components/common';
import { queryStatusClass } from '@/utils';
import Footer from './Footer.vue';
import axios from 'axios';

export default {
  name: 'Home',
  components: {
    Header,
    RenderDeleteModal,
    RenderSpinner,
    Footer,
  },
  data: function() {
    if (['SHOP', 'COMPLIANCE'].includes(localStorage.getItem('role'))) {
      return {
        featureMultiOffer: false,
        fields: [
          {
            key: 'queryId',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'sellerOfferNr',
            label: this.$t('OFFER'),
            sortable: true,
          },
          {
            key: 'lendifyRefno',
            label: this.$t('CONTRACT_NUMBER_SHORT'),
            sortable: true,
          },
          {
            key: 'createdByName',
            label: this.$t('CREATED_BY'),
            sortable: true,
          },
          {
            key: 'custName',
            label: this.$t('CLIENT'),
            sortable: true,
          },
          {
            key: 'contractAmount',
            label: this.$t('CONTRACT_AMOUNT'),
            sortable: true,
          },
          {
            key: 'status',
            label: this.$t('STATUS'),
            sortable: true,
          },
          {
            key: 'actions',
            label: this.$t('ACTIONS'),
            sortable: false,
          },
        ],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        rowsPerPage: [5, 10, 20, 50, 100],
        filter: null,
        allSelected: this.selectedAll(),
        queries: [],
        selected: this.selectedByDefault(),
        statusKeys: Object.keys(this.$store.state.queryStatus),
        showAnnulModal: false,
        selectedQuery: 0,
        selectedQueryIndex: 0,
        dashboardMessage: null,
        editDasboardMessage: false,
        partnerLimitCheckUrl: null,
        // Quick Offer modal
        showQuickOfferModal: false,
        quickOfferFiles: [],
        quickOfferDragging: false,
        quickOfferPrompt: 'Palun koosta pakkumine',
        quickOfferSubmitting: false,
        // Limit Requests tab data
        showLimitChecks: false,
        limitRequests: [],
        limitFilter: null,
        limitCurrentPage: 1,
        limitPerPage: 10,
        limitTotalRows: 0,
        limitRequestsLoading: false,
        limitStatusSelected: ['approved', 'rejected', 'pending', 'timeout'],
        limitAllSelected: true,
        limitFields: [
          { key: 'limitId', label: 'ID', sortable: true },
          { key: 'partnerName', label: this.$t('PARTNER_NAME'), sortable: true },
          { key: 'companyName', label: this.$t('COMPANY'), sortable: true },
          { key: 'requestedLimit', label: this.$t('REQUESTED_LIMIT'), sortable: true },
          { key: 'lastResult', label: this.$t('STATUS'), sortable: true },
          { key: 'issuedLimit', label: this.$t('ISSUED_LIMIT'), sortable: true },
          { key: 'createdAt', label: this.$t('CREATED_AT'), sortable: true },
          { key: 'actions', label: '' },
        ],
      };
    } else {
      return {
        featureMultiOffer: false,
        fields: [
          {
            key: 'queryId',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'createdByName',
            label: this.$t('CREATED_BY'),
            sortable: true,
          },
          {
            key: 'custName',
            label: this.$t('CLIENT'),
            sortable: true,
          },
          {
            key: 'contractAmount',
            label: this.$t('CONTRACT_AMOUNT'),
            sortable: true,
          },
          {
            key: 'status',
            label: this.$t('STATUS'),
            sortable: true,
          },
          {
            key: 'actions',
            label: this.$t('ACTIONS'),
            sortable: false,
          },
        ],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        rowsPerPage: [5, 10, 20, 50, 100],
        filter: null,
        allSelected: this.selectedAll(),
        queries: [],
        selected: this.selectedByDefault(),
        statusKeys: Object.keys(this.$store.state.queryStatus),
        showAnnulModal: false,
        selectedQuery: 0,
        selectedQueryIndex: 0,
        dashboardMessage: null,
        editDasboardMessage: false,
        partnerLimitCheckUrl: null,
        // Quick Offer modal
        showQuickOfferModal: false,
        quickOfferFiles: [],
        quickOfferDragging: false,
        quickOfferPrompt: 'Palun koosta pakkumine',
        quickOfferSubmitting: false,
        // Limit Requests tab data
        showLimitChecks: false,
        limitRequests: [],
        limitFilter: null,
        limitCurrentPage: 1,
        limitPerPage: 10,
        limitTotalRows: 0,
        limitRequestsLoading: false,
        limitStatusSelected: ['approved', 'rejected', 'pending', 'timeout'],
        limitAllSelected: true,
        limitFields: [
          { key: 'limitId', label: 'ID', sortable: true },
          { key: 'partnerName', label: this.$t('PARTNER_NAME'), sortable: true },
          { key: 'companyName', label: this.$t('COMPANY'), sortable: true },
          { key: 'requestedLimit', label: this.$t('REQUESTED_LIMIT'), sortable: true },
          { key: 'lastResult', label: this.$t('STATUS'), sortable: true },
          { key: 'issuedLimit', label: this.$t('ISSUED_LIMIT'), sortable: true },
          { key: 'createdAt', label: this.$t('CREATED_AT'), sortable: true },
          { key: 'actions', label: '' },
        ],
      };
    }
  },
  created: function() {
    this.getDashboardMessage();
    this.fetchQueries({
      newPage: this.currentPage,
      pageSize: this.perPage,
      searchParam: this.filter,
      queryfilters: this.selected,
    });
  },
  computed: {
    ...mapState(['loading']),
    pageOptions() {
      return this.rowsPerPage.map(i => {
        return { text: this.$t('ROWS_PER_PAGE') + ': ' + i, value: i };
      });
    },
    getStatusOptions() {
      return this.statusKeys.map(s => {
        return { text: this.$t(`QUERYSTATUS.${s}`), value: s };
      });
    },
    filteredQueries() {
      return this.queries.filter(q => this.selected.includes(q.status));
    },
    filteredLimitRequests() {
      let filtered = this.limitRequests;

      // Filter by status
      filtered = filtered.filter(req => this.limitStatusSelected.includes(req.lastResult));

      // Filter by text search
      if (this.limitFilter) {
        const filterLower = this.limitFilter.toLowerCase();
        filtered = filtered.filter(req => {
          return (
            (req.companyName && req.companyName.toLowerCase().includes(filterLower)) ||
            (req.partnerName && req.partnerName.toLowerCase().includes(filterLower)) ||
            (req.limitId && req.limitId.toString().includes(filterLower))
          );
        });
      }

      return filtered;
    },
    limitStatusOptions() {
      return [
        { text: 'Kinnitatud', value: 'approved' },
        { text: 'Tagasi lükatud', value: 'rejected' },
        { text: 'Ootel', value: 'pending' },
        { text: 'Käsitsi läbivaatamine', value: 'timeout' },
      ];
    },
    visibleLimitFields() {
      // For PARTNER/SHOP roles, hide the partnerName column
      if (['PARTNER', 'SHOP'].includes(this.role)) {
        return this.limitFields.filter(field => field.key !== 'partnerName');
      }
      // For COMPLIANCE/CREDIT, show all columns
      return this.limitFields;
    },
    role() {
      return localStorage.getItem('role');
    },
  },
  methods: {
    ...mapActions('alert', [ALERT]),
    statusStyle(status) {
      return queryStatusClass(status);
    },
    selectedByDefault: function() {
      if (['SHOP'].includes(localStorage.getItem('role'))) {
        return Object.keys(this.$store.state.queryStatus);
      } else {
        return Object.keys(this.$store.state.queryStatus).filter(function(
          item,
        ) {
          return !['P'].includes(item);
        });
      }
    },
    selectedAll: function() {
      const selected = this.selectedByDefault();
      return Object.keys(this.$store.state.queryStatus).every(v =>
        selected.includes(v),
      );
    },
    toggleAll(checked) {
      this.selected = checked ? this.statusKeys.slice() : [];
    },
    annulQuery: function(payload) {
      let query = this.filteredQueries[payload.index];
      this.$store
        .dispatch('annulQuery', payload.id)
        .then(() => {
          this.ALERT({ message: this.$t('QUERY_ANNULLED'), type: 'success' });
          query.status = 'N';
        })
        .catch(() => {
          this.queries.splice(payload.index, 1, query);
        });
    },
    openAnnulModal(id, index) {
      this.showAnnulModal = true;
      this.selectedQuery = id;
      this.selectedQueryIndex = index;
    },
    closeAnnulModal(doAnnul) {
      this.showAnnulModal = false;
      if (doAnnul) {
        this.annulQuery({
          id: this.selectedQuery,
          index: this.selectedQueryIndex,
        });
      }
      this.selectedQuery = 0;
      this.selectedQueryIndex = 0;
    },
    // Quick Offer methods
    openQuickOfferModal() {
      this.showQuickOfferModal = true;
    },
    handleQuickOfferFiles(event) {
      const files = event.target.files || event.dataTransfer?.files;
      if (files) {
        this.quickOfferFiles = [...this.quickOfferFiles, ...Array.from(files)];
      }
      // Reset input so the same file can be re-selected
      if (event.target && event.target.value) {
        event.target.value = '';
      }
    },
    handleQuickOfferDrop(event) {
      this.quickOfferDragging = false;
      const files = event.dataTransfer?.files;
      if (files) {
        this.quickOfferFiles = [...this.quickOfferFiles, ...Array.from(files)];
      }
    },
    removeQuickOfferFile(index) {
      this.quickOfferFiles.splice(index, 1);
    },
    resetQuickOffer() {
      this.quickOfferFiles = [];
      this.quickOfferDragging = false;
      this.quickOfferPrompt = 'Palun koosta pakkumine';
      this.quickOfferSubmitting = false;
    },
    async submitQuickOffer() {
      this.quickOfferSubmitting = true;

      try {
        // Convert all files to data URLs
        const filePromises = this.quickOfferFiles.map(file => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve({
              name: file.name,
              dataUrl: reader.result,
              mimeType: file.type || 'application/octet-stream',
            });
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        });
        const files = await Promise.all(filePromises);

        // Close modal and open widget with prompt + files
        this.showQuickOfferModal = false;
        if (window.AssistantWidget && window.AssistantWidget.openWithPrompt) {
          window.AssistantWidget.openWithPrompt(this.quickOfferPrompt, files);
        }
      } catch (error) {
        console.error('Error preparing quick offer files:', error);
      } finally {
        this.quickOfferSubmitting = false;
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.fetchQueries({
        newPage: this.currentPage,
        pageSize: this.perPage,
        searchParam: this.filter,
        queryfilters: this.selected,
      });
    },
    async getDashboardMessage() {
      await this.$store
        .dispatch('getDashboardMessage')
        .then(response => {
          this.dashboardMessage = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async deleteDashboardMessage() {
      await this.$store
        .dispatch('saveDashboardMessage', { text: null })
        .then(response => {
          this.dashboardMessage = null;
          this.editDasboardMessage = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async saveDashboardMessage() {
      // encodeURIComponent is needed to convert special characters
      // to be used in URL
      await this.$store
        .dispatch('saveDashboardMessage', { text: this.dashboardMessage })
        .then(response => {
          this.editDasboardMessage = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchQueries({ newPage, pageSize, searchParam, queryfilters }) {
      const action = ['PARTNER', 'SHOP'].includes(this.role)
        ? 'getPartnerQueriesByStatus'
        : 'findAllQueries';

      const args = {
        statuses: queryfilters,
        params: { page: newPage - 1, pageSize, searchParam },
      };

      this.$store
        .dispatch(action, args)
        .then(response => {
          this.queries = response.data.content.map(obj => ({
            ...obj,
            actions: { edit: 'edit', delete: 'delete' },
          }));
          this.totalRows = response.data.totalElements;
        })
        .catch(error => {
          console.log(error);
        });

      if (this.role === 'CREDIT') {
        this.fields.splice(1, 0, {
          key: 'formattedCreatedDtime',
          label: this.$t('CREATED'),
          sortable: true,
        });
      }
    },
    // Limit Requests methods
    async fetchLimitRequests() {
      this.limitRequestsLoading = true;
      try {
        // Note: The backend automatically filters based on user role:
        // - PARTNER: sees only their own partner's limit requests
        // - COMPLIANCE/CREDIT: see all limit requests from all partners
        const response = await axios.get('/limit-requests', {
          params: {
            source: 'self_service_limit_check',
          },
        });

        // Validate response data is an array
        if (!response.data || !Array.isArray(response.data)) {
          console.error('Invalid response format:', response.data);
          throw new Error('Invalid response format from server');
        }

        // Map the response data to our format
        this.limitRequests = response.data.map(lr => ({
          limitId: lr.id,
          companyName: lr.company_name
            ? `${lr.company_name} (${lr.regno})`
            : lr.regno,
          partnerName: lr.partner,
          requestedLimit: lr.amount,
          lastResult: lr.result_status || 'pending',
          issuedLimit: lr.result_amount,
          createdAt: lr.created_at,
        }));
        this.limitTotalRows = this.limitRequests.length;

        console.log(`Loaded ${this.limitRequests.length} limit requests`);
      } catch (error) {
        console.error('Error fetching limit requests:', error);

        // Show detailed error message
        let errorMessage = 'Failed to load limit requests';
        if (error.response) {
          // Server responded with error
          errorMessage = error.response.data?.message || error.response.data || errorMessage;
          console.error('Server error:', error.response.status, error.response.data);
        } else if (error.request) {
          // Request made but no response
          errorMessage = 'No response from server. Please check your connection.';
          console.error('No response received:', error.request);
        } else {
          // Error in request setup
          errorMessage = error.message || errorMessage;
        }

        this.ALERT({
          message: errorMessage,
          type: 'error'
        });

        // Reset data on error
        this.limitRequests = [];
        this.limitTotalRows = 0;
      } finally {
        this.limitRequestsLoading = false;
      }
    },
    onTabChange(newTabIndex) {
      // Tab 1 = Limit Requests (for PARTNER, SHOP, COMPLIANCE, CREDIT roles)
      if (newTabIndex === 1 && this.showLimitChecks && ['PARTNER', 'SHOP', 'COMPLIANCE', 'CREDIT'].includes(this.role)) {
        if (this.limitRequests.length === 0) {
          this.fetchLimitRequests();
        }
      }
    },
    resultStyle(result) {
      if (result === 'approved') return 'status-success';
      if (result === 'rejected') return 'status-danger';
      if (result === 'pending') return 'status-warning';
      return 'status-secondary';
    },
    formatResult(result) {
      if (!result) return '-';
      const resultMap = {
        approved: 'Kinnitatud',
        rejected: 'Tagasi lükatud',
        pending: 'Ootel',
        timeout: 'Käsitsi läbivaatamine',
      };
      return resultMap[result] || result;
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('et-EE') + ' ' + date.toLocaleTimeString('et-EE', { hour: '2-digit', minute: '2-digit' });
    },
    toggleAllLimitFilters(checked) {
      this.limitStatusSelected = checked ? ['approved', 'rejected', 'pending', 'timeout'] : [];
    },
    copyPartnerLimitCheckUrl() {
      if (!this.partnerLimitCheckUrl) return;

      // Try modern clipboard API first
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.partnerLimitCheckUrl).then(() => {
          this.$bvToast.toast(this.$t('LIMIT_CHECK_URL_COPIED'), {
            title: this.$t('SUCCESS'),
            variant: 'success',
            solid: true,
          });
        }).catch(err => {
          console.error('Failed to copy:', err);
          this.fallbackCopyTextToClipboard(this.partnerLimitCheckUrl);
        });
      } else {
        // Fallback for older browsers
        this.fallbackCopyTextToClipboard(this.partnerLimitCheckUrl);
      }
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$bvToast.toast(this.$t('LIMIT_CHECK_URL_COPIED'), {
            title: this.$t('SUCCESS'),
            variant: 'success',
            solid: true,
          });
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    },
  },
  async mounted() {
    // Fetch partner details to check if limit checks are enabled
    // For PARTNER/SHOP roles: check their own partner settings
    // For COMPLIANCE/CREDIT: always enable (they see all)
    if (this.role === 'PARTNER') {
      try {
        const response = await this.$store.dispatch('getPartnerDetails');
        const partner = response.data;
        this.showLimitChecks = partner.showLimitChecks || false;
        this.partnerLimitCheckUrl = partner.limitCheckUrl || null;
      } catch (error) {
        console.log('Error fetching partner details:', error);
      }
    } else if (this.role === 'SHOP') {
      try {
        const response = await this.$store.dispatch('getPartnerDetails');
        const partner = response.data;
        this.showLimitChecks = partner.showLimitChecks || false;
        this.featureMultiOffer = partner.featureMultiOffer || false;
      } catch (error) {
        console.log('Error fetching partner details:', error);
      }
    } else if (['COMPLIANCE', 'CREDIT'].includes(this.role)) {
      // Admin roles always have access to limit requests
      this.showLimitChecks = true;
    }
  },
  watch: {
    selected(newVal, oldVal) {
      this.allSelected = newVal.length === this.statusKeys.length;
      this.currentPage = 1;
      this.fetchQueries({
        newPage: this.currentPage,
        pageSize: this.perPage,
        searchParam: this.filter,
        queryfilters: this.selected,
      });
    },
    perPage(newPerPage) {
      this.perPage = newPerPage;
      this.currentPage = 1;
      this.fetchQueries({
        newPage: this.currentPage,
        pageSize: this.perPage,
        searchParam: this.filter,
        queryfilters: this.selected,
      });
    },
    filter(newVal) {
      this.currentPage = 1;
      this.fetchQueries({
        newPage: this.currentPage,
        pageSize: this.perPage,
        searchParam: newVal,
        queryfilters: this.selected,
      });
    },
    limitStatusSelected(newVal) {
      this.limitAllSelected = newVal.length === 4; // 4 possible statuses
      this.limitCurrentPage = 1;
    },
  },
};
</script>

<style scoped>
.truncate {
  max-width: 125px; /* Adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Status badge styles for limit requests */
.status {
  padding: 7px 10px;
  border-radius: 50px;
  min-width: 90px;
  text-align: center;
  line-height: 100%;
  font-weight: bold;
  font-size: 0.7rem;
  display: inline-block;
  white-space: nowrap;
  border: 1px solid #ccc;
}

.status-success {
  background-color: #e2ffe1;
  border-color: #97d295;
  color: #125c10;
}

.status-danger {
  background-color: #fdeaea;
  border-color: #f2b1b1;
  color: #eb5555;
}

.status-warning {
  background-color: #fffce1;
  border-color: #dbbe5b;
  color: #62562d;
}

.status-secondary {
  background-color: #fcfcfc;
  border-color: #dedede;
  color: #8e8e8e;
}

.table-status {
  display: inline-block;
}

/* CTA Cards */
.cta-cards-row {
  display: flex;
  gap: 1.25rem;
}

.cta-card {
  flex: 1;
  border-radius: 16px;
  padding: 1.75rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  text-decoration: none;
  min-height: 160px;
  transition: box-shadow 0.2s, transform 0.15s;
  cursor: pointer;
}

.cta-card:hover {
  transform: translateY(-2px);
  text-decoration: none;
}

.cta-card--white {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  color: #333;
}

.cta-card--white:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  color: #333;
}

.cta-card--purple {
  background: #822460;
  border: none;
  box-shadow: 0 2px 12px rgba(130, 36, 96, 0.25);
  color: #fff;
  cursor: default;
}

.cta-card--purple:hover {
  box-shadow: 0 4px 20px rgba(130, 36, 96, 0.35);
  transform: none;
}

.cta-card__content {
  margin-bottom: 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.cta-card__title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.35rem;
}

.cta-card__title--light {
  color: #fff;
}

.cta-card__desc {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0;
}

.cta-card__desc--light {
  color: rgba(255, 255, 255, 0.85);
}

.cta-card__btn {
  padding: 8px 24px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
}

.cta-card__btn--outline {
  background: #fff;
  color: #333;
  border: 1.5px solid #333;
}

.cta-card__btn--outline:hover {
  background: #f5f5f5;
}

.cta-card__btn--white {
  background: #fff;
  color: #822460;
  border: none;
}

.cta-card__btn--white:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .cta-cards-row {
    flex-direction: column;
  }
}

/* Quick Offer Modal */
.quick-offer-dropzone {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: 12px;
  padding: 2rem;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  text-align: center;
}

.quick-offer-dropzone:hover {
  border-color: #822460;
  background-color: #fdf5fa;
}

.quick-offer-dropzone--dragging {
  border-color: #822460;
  background-color: #fdf5fa;
}

.quick-offer-dropzone__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666;
}

.quick-offer-file-input {
  display: none;
}

.quick-offer-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
}

.quick-offer-file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.5rem;
}

.quick-offer-file-remove {
  background: none;
  border: none;
  color: #999;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0 0.25rem;
  line-height: 1;
}

.quick-offer-file-remove:hover {
  color: #e53e3e;
}
</style>
